import { createContext, FC, useEffect, useMemo, useState } from 'react';
import { useI18n } from 'src/hooks/use-i18n-translation';
import { getFooterConfigs } from 'src/services/cmsApi';
import { CmsWebsiteFooter, CmsWidget } from 'src/types/cms/cmsWidgetTypes';
import DesktopFooterConstructor from './DesktopFooterConstructor';
import MobileFooterConstructor from './MobileFooterConstructor';
import TabletFooterConstructor from './TabletFooterConstructor';

export const FooterContext = createContext<CmsWidget<CmsWebsiteFooter> | null>(null);

export const FooterConstructor: FC<{ type: 'desktop' | 'mobile' | 'tablet' }> = ({ type }) => {
  const { locale } = useI18n();
  const [footerConfigs, setFooterConfigs] = useState<CmsWidget<CmsWebsiteFooter> | null>(null);
  const FooterComponent = useMemo(() => {
    switch (type) {
      case 'desktop':
        return DesktopFooterConstructor;
      case 'mobile':
        return MobileFooterConstructor;
      case 'tablet':
        return TabletFooterConstructor;
    }
  }, [type]);

  useEffect(() => {
    getFooterConfigs(locale).then((res) => {
      if (res.success) {
        setFooterConfigs(res.result[0]);
      }
    });
  }, [locale]);

  return (
    <FooterContext.Provider value={footerConfigs}>
      <FooterComponent />
    </FooterContext.Provider>
  );
};
